var map = {
	"./2.svg": [
		48524,
		8524
	],
	"./CloseIconRedCircle.svg": [
		48317,
		8317
	],
	"./accountIcon.svg": [
		38501,
		8501
	],
	"./add-seller.svg": [
		53330,
		3330
	],
	"./addIconGray.svg": [
		74459,
		4459
	],
	"./age.svg": [
		59102,
		9102
	],
	"./alertIcon.svg": [
		6246,
		6246
	],
	"./allNumberIconWhite.svg": [
		95114,
		9532
	],
	"./amazonIcon.svg": [
		43018,
		2176
	],
	"./amazon_ld_cu.svg": [
		80331,
		331
	],
	"./amazon_logo_wob_lg.svg": [
		50522,
		522
	],
	"./arrow-btn.svg": [
		45662,
		5662
	],
	"./arrowDownIcon.svg": [
		94978,
		4978
	],
	"./arrowGreen.svg": [
		66179,
		6179
	],
	"./arrowGreenNotif.svg": [
		26191,
		6191
	],
	"./arrowRed.svg": [
		74080,
		4080
	],
	"./arrowSendIcon.svg": [
		85265,
		5265
	],
	"./arrow_w.svg": [
		87054,
		7054
	],
	"./attachBlueIcon.svg": [
		11351,
		1351
	],
	"./attachDark.svg": [
		71198,
		1198
	],
	"./attachIcon.svg": [
		4935,
		4935
	],
	"./backIcon.svg": [
		34328,
		4328
	],
	"./backIconGreen.svg": [
		81134,
		1134
	],
	"./backIconWhite.svg": [
		28282,
		8282
	],
	"./barChart.svg": [
		86527,
		6527
	],
	"./basket-category.svg": [
		61642,
		1642
	],
	"./bellIcon.svg": [
		80352,
		352
	],
	"./bookmark-fill.svg": [
		90859,
		859
	],
	"./bookmark.svg": [
		82333,
		2333
	],
	"./bookmark_white.svg": [
		38091,
		8091
	],
	"./bookmark_white_s.svg": [
		55077,
		5077
	],
	"./boxChart.svg": [
		26582,
		6582
	],
	"./boxIcon.svg": [
		66443,
		6443
	],
	"./box_o.svg": [
		31827,
		1827
	],
	"./cal.svg": [
		38741,
		8741
	],
	"./calenderIconGray.svg": [
		77269,
		7269
	],
	"./calenderWhite.svg": [
		96428,
		6428
	],
	"./calender_gray_s.svg": [
		39913,
		9913
	],
	"./cameraIcon.svg": [
		15519,
		5519
	],
	"./chartIcon.svg": [
		47456,
		7456
	],
	"./chartIconBlack.svg": [
		90289,
		289
	],
	"./chart_ic.svg": [
		23908,
		3908
	],
	"./checkIcon.svg": [
		63300,
		8053
	],
	"./checkedIcon.svg": [
		40614,
		614
	],
	"./checkmark.svg": [
		559,
		559
	],
	"./clickIconWhite.svg": [
		48277,
		8277
	],
	"./clockIcon.svg": [
		75295,
		5295
	],
	"./clockIconGray.svg": [
		62654,
		2654
	],
	"./closeCollapse.svg": [
		36213,
		6213
	],
	"./closeIcon.svg": [
		31968,
		1968
	],
	"./closeWhite.svg": [
		96003,
		6003
	],
	"./coin.svg": [
		57308,
		7308
	],
	"./comment-icon.svg": [
		79230,
		9230
	],
	"./commentIcon.svg": [
		93696,
		3696
	],
	"./comments-log.svg": [
		98477,
		8477
	],
	"./comments.svg": [
		88568,
		8568
	],
	"./compare-icon.svg": [
		2437,
		2437
	],
	"./copyIconBlue.svg": [
		59559,
		9559
	],
	"./cross.svg": [
		89251,
		9251
	],
	"./cube.svg": [
		28262,
		8262
	],
	"./customer-club-route-icon.svg": [
		13948,
		3948
	],
	"./dashboardIcon.svg": [
		55660,
		5660
	],
	"./dashboardIconActive.svg": [
		66521,
		6521
	],
	"./dateIcon.svg": [
		11789,
		1789
	],
	"./deleteIconDark.svg": [
		39828,
		9828
	],
	"./details-icon.svg": [
		49939,
		9939
	],
	"./dideban_logo_blue.svg": [
		18678,
		8678
	],
	"./disLikeIcon.svg": [
		39051,
		9051
	],
	"./dislike.svg": [
		29139,
		9139
	],
	"./dislikeIconGray.svg": [
		17905,
		7905
	],
	"./dislikeRed.svg": [
		66365,
		6365
	],
	"./dislike_white.svg": [
		2643,
		2643
	],
	"./dislike_white_s.svg": [
		47786,
		7786
	],
	"./documentIcon.svg": [
		80760,
		760
	],
	"./downloadFileIcon.svg": [
		17970,
		7970
	],
	"./downloadIcon.svg": [
		79330,
		9330
	],
	"./downloadIconBlack.svg": [
		31583,
		1583
	],
	"./drupdownIconDown.svg": [
		86841,
		6841
	],
	"./edit.svg": [
		94486,
		4486
	],
	"./editIcon.svg": [
		35229,
		5229
	],
	"./editIconBlue.svg": [
		60609,
		609
	],
	"./editIconDark.svg": [
		36422,
		6422
	],
	"./editIconGray.svg": [
		9258,
		9258
	],
	"./editIconWhite.svg": [
		97203,
		7203
	],
	"./edit_or.svg": [
		14579,
		4579
	],
	"./education.svg": [
		65540,
		5540
	],
	"./ellipsis-vertical-solid.svg": [
		84836,
		4836
	],
	"./emailIconWhite.svg": [
		11876,
		1876
	],
	"./emailNotifIcon.svg": [
		28195,
		8195
	],
	"./email_dash.svg": [
		94015,
		4015
	],
	"./emoji1.svg": [
		91684,
		1684
	],
	"./emoji2.svg": [
		44640,
		4640
	],
	"./emoji3.svg": [
		33334,
		3334
	],
	"./emoji4.svg": [
		42912,
		2912
	],
	"./emoji5.svg": [
		97321,
		7321
	],
	"./emoji_g.svg": [
		51108,
		1108
	],
	"./emptyStarIcon.svg": [
		60851,
		851
	],
	"./england-flag.svg": [
		58738,
		8738
	],
	"./erthIconWhite.svg": [
		82979,
		2979
	],
	"./excelIcon.svg": [
		9060,
		9060
	],
	"./exel_ic_gr.svg": [
		72113,
		2113
	],
	"./exitpanelIcon.svg": [
		72108,
		2108
	],
	"./eye.svg": [
		94453,
		2033
	],
	"./eyeIcon.svg": [
		20208,
		208
	],
	"./eye_white.svg": [
		90970,
		970
	],
	"./eye_white_s.svg": [
		27671,
		7671
	],
	"./file_ic_vi.svg": [
		89190,
		9190
	],
	"./forum-icon.svg": [
		77092,
		7092
	],
	"./giftIcon.svg": [
		46996,
		6996
	],
	"./google-btn.svg": [
		45374,
		5374
	],
	"./gridViewIcon.svg": [
		93717,
		3717
	],
	"./gridViewIconBlue.svg": [
		24453,
		4453
	],
	"./hambergerIcon.svg": [
		39109,
		9109
	],
	"./home_blue.svg": [
		96157,
		6157
	],
	"./home_gray.svg": [
		35115,
		5115
	],
	"./horizantalDots.svg": [
		31976,
		1976
	],
	"./imageIcon.svg": [
		83922,
		3922
	],
	"./iran-flag.svg": [
		20850,
		850
	],
	"./item_sub.svg": [
		26090,
		6090
	],
	"./language.svg": [
		48841,
		8841
	],
	"./light_r copy.svg": [
		97439,
		7439
	],
	"./light_r.svg": [
		51728,
		1728
	],
	"./like.svg": [
		93937,
		3937
	],
	"./likeGreen.svg": [
		72590,
		2590
	],
	"./likeIcon.svg": [
		16010,
		6010
	],
	"./like_white.svg": [
		61619,
		1619
	],
	"./list.svg": [
		95752,
		5752
	],
	"./listViewIcons.svg": [
		80512,
		512
	],
	"./listViewIconsBlue.svg": [
		42314,
		2314
	],
	"./loca_dash.svg": [
		97610,
		7610
	],
	"./locationIcon.svg": [
		97742,
		7742
	],
	"./locationIconGray.svg": [
		17984,
		7984
	],
	"./locationIconWhite.svg": [
		21401,
		1401
	],
	"./lock.svg": [
		84642,
		4642
	],
	"./map-pin.svg": [
		61793,
		1793
	],
	"./messageIcon.svg": [
		51081,
		1081
	],
	"./message_b.svg": [
		38851,
		8851
	],
	"./message_berger_menu.svg": [
		37128,
		7128
	],
	"./min_red.svg": [
		15640,
		5640
	],
	"./minus-red.svg": [
		65672,
		5672
	],
	"./mokaabIconWhite.svg": [
		39612,
		9612
	],
	"./more_white.svg": [
		67642,
		7642
	],
	"./newIcon.svg": [
		48146,
		8146
	],
	"./notificationIcon.svg": [
		8010,
		8010
	],
	"./openCollapse.svg": [
		7634,
		7634
	],
	"./otherDotsIcon.svg": [
		19912,
		9912
	],
	"./otherDotsIconWhite.svg": [
		62039,
		2039
	],
	"./percentIcon.svg": [
		65488,
		5488
	],
	"./personIcon.svg": [
		6487,
		6487
	],
	"./person_v.svg": [
		69709,
		9709
	],
	"./person_white.svg": [
		36228,
		6228
	],
	"./phone.svg": [
		22397,
		2397
	],
	"./phoneIcon.svg": [
		26591,
		6591
	],
	"./phoneIconWhite.svg": [
		20468,
		468
	],
	"./pic_ic_ba.svg": [
		52643,
		8464
	],
	"./pin.svg": [
		16871,
		6871
	],
	"./plus-green.svg": [
		85872,
		5872
	],
	"./plusIcon.svg": [
		51266,
		1266
	],
	"./plusIconLarge.svg": [
		63169,
		3169
	],
	"./plus_green.svg": [
		32223,
		2223
	],
	"./printIcon.svg": [
		9419,
		9419
	],
	"./rate_header copy.svg": [
		46007,
		6007
	],
	"./rate_header.svg": [
		25683,
		5683
	],
	"./rate_ic.svg": [
		10457,
		457
	],
	"./ratingIcon.svg": [
		29291,
		9291
	],
	"./redCloseIcon.svg": [
		55221,
		5221
	],
	"./reportsIcon.svg": [
		68066,
		8558
	],
	"./resturant-menu.svg": [
		18892,
		8892
	],
	"./rocket_e.svg": [
		14661,
		4661
	],
	"./sandTimer.svg": [
		42269,
		2269
	],
	"./sandTimerDark.svg": [
		23312,
		3312
	],
	"./saveIcon.svg": [
		54541,
		4541
	],
	"./saveIconWhite.svg": [
		36472,
		6472
	],
	"./scale-up.svg": [
		70599,
		599
	],
	"./scan_blue.svg": [
		30058,
		58
	],
	"./scoreIcon.svg": [
		98438,
		8438
	],
	"./scoreIconGray.svg": [
		31191,
		1191
	],
	"./searchIcon.svg": [
		80577,
		577
	],
	"./search_gray_s.svg": [
		52894,
		2894
	],
	"./search_ic_gr.svg": [
		43139,
		3139
	],
	"./seller.svg": [
		30225,
		225
	],
	"./sendArrow.svg": [
		78296,
		8296
	],
	"./settingIcon.svg": [
		31154,
		1154
	],
	"./shareBlue.svg": [
		43518,
		3518
	],
	"./shareIcon.svg": [
		73277,
		3277
	],
	"./share_c.svg": [
		4133,
		4133
	],
	"./share_white.svg": [
		12638,
		2638
	],
	"./sidebar/basket.svg": [
		5114,
		5114
	],
	"./sidebar/bests.svg": [
		29596,
		9596
	],
	"./sidebar/club.svg": [
		40585,
		585
	],
	"./sidebar/comment.svg": [
		13146,
		3146
	],
	"./sidebar/dashboard.svg": [
		64573,
		4573
	],
	"./sidebar/discount.svg": [
		34000,
		4000
	],
	"./sidebar/messages.svg": [
		34643,
		4643
	],
	"./sidebar/organizations.svg": [
		4812,
		4812
	],
	"./sidebar/profile.svg": [
		46099,
		6099
	],
	"./sidebar/reports.svg": [
		4492,
		4492
	],
	"./sidebar/restaurant.svg": [
		77638,
		7638
	],
	"./sidebar/scan.svg": [
		6,
		6
	],
	"./sidebar/scores.svg": [
		38062,
		8062
	],
	"./sidebar/settings.svg": [
		98918,
		8918
	],
	"./sidebar/social-networks.svg": [
		7261,
		7261
	],
	"./smartIcon.svg": [
		67373,
		7373
	],
	"./speakerIcon.svg": [
		2104,
		2104
	],
	"./stack_gray.svg": [
		95011,
		5011
	],
	"./stack_ic.svg": [
		80373,
		373
	],
	"./stack_ic_blue.svg": [
		97217,
		7217
	],
	"./star-fill.svg": [
		40544,
		544
	],
	"./star-half.svg": [
		18582,
		8582
	],
	"./star.svg": [
		50386,
		386
	],
	"./starGray.svg": [
		91740,
		1740
	],
	"./starIcon.svg": [
		1475,
		1475
	],
	"./starIconWhite.svg": [
		92739,
		2739
	],
	"./starIconYellow.svg": [
		15753,
		5753
	],
	"./star_blue.svg": [
		94152,
		4152
	],
	"./star_gray.svg": [
		37761,
		7761
	],
	"./star_m.svg": [
		58960,
		8960
	],
	"./statusIcon.svg": [
		643,
		643
	],
	"./tableFiltericon.svg": [
		35921,
		5921
	],
	"./target.svg": [
		77687,
		7687
	],
	"./three-coin-icon.svg": [
		46185,
		6185
	],
	"./time.svg": [
		53960,
		3960
	],
	"./time_blue.svg": [
		99735,
		9735
	],
	"./time_gray.svg": [
		86709,
		6709
	],
	"./time_v.svg": [
		35127,
		5127
	],
	"./trash.svg": [
		81543,
		1543
	],
	"./trashIcon.svg": [
		28106,
		8106
	],
	"./trashIconBlue.svg": [
		69154,
		9154
	],
	"./two-color-user.svg": [
		90917,
		917
	],
	"./user-icon.svg": [
		36612,
		6612
	],
	"./user.svg": [
		58837,
		8837
	],
	"./userEditIcon.svg": [
		83993,
		3993
	],
	"./userIcon.svg": [
		65396,
		5396
	],
	"./userSmallIcon.svg": [
		23820,
		3820
	],
	"./user_messages_ic.svg": [
		64314,
		4314
	],
	"./voiceIcon.svg": [
		88848,
		8848
	],
	"./walletIcon.svg": [
		35606,
		5606
	],
	"./wallet_coins.svg": [
		26171,
		6171
	],
	"./wallet_mo.svg": [
		39045,
		9045
	],
	"./windowIcon.svg": [
		6173,
		6173
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 35732;
module.exports = webpackAsyncContext;